/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CubeLineValueForTabRequest,
  CubeLineValueForTabResponse,
  UpdateCubeLineValueForTabRequest,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectCubeLineClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectCubeLine
   * @summary Получить значение лайна для вкладки
   * @request POST:/bff/ProjectCubeLine/value/for_tab
   * @secure
   */
  projectCubeLineGetCubeLineValueForTab = (
    data: CubeLineValueForTabRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CubeLineValueForTabResponse, any>({
      path: `/bff/ProjectCubeLine/value/for_tab`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectCubeLine
   * @summary Обновление значения лайна для вкладки
   * @request PUT:/bff/ProjectCubeLine/value/for_tab
   * @secure
   */
  projectCubeLineUpdateCubeLineValueForTab = (
    data: UpdateCubeLineValueForTabRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, string>({
      path: `/bff/ProjectCubeLine/value/for_tab`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
}
